import { useState } from "react";
import { Mixpanel } from "./Mixpanel";

export function useMixpanel() {
  const [mixpanel, setMixpanel] = useState<Mixpanel>(Mixpanel.getInstance());

  return mixpanel;
}
